<template>
  <!-- 抽屉详情 -->
  <el-dialog
    v-dragDialog
    :title="drawerTitle"
    :visible.sync="drawerVisible"
    width="1000px"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-width="120px"
      :rules="formRules"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <shortOrderInfo ref="shortOrderInfo" :order="order" />
        </el-col>
        <el-col :span="12">
          <el-card shadow="never">
            <div slot="header">
              <span>{{ drawerTitle }}</span>
              <div style="float: right; display: flex">
                <el-tag type="success">历史库选择：</el-tag>
                <workerSelector ref="workderSelector" @change="workerChanged" />
              </div>
            </div>
            <el-form-item label="姓名：" prop="name">
              <el-input
                v-model="dataForm.name"
                style="width: 100%"
                auto-complete="off"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="电话：" prop="mobile">
              <el-input
                v-model="dataForm.mobile"
                style="width: 100%"
                auto-complete="off"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="佣金金额：" prop="commission">
              <el-input-number
                :precision="2"
                v-model="dataForm.commission"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="好评奖励：" prop="bonos">
              <el-input-number
                :precision="2"
                v-model="dataForm.bonos"
              ></el-input-number>
            </el-form-item>
          </el-card>
        </el-col>
      </el-row>
      <el-row v-if="false">
        <el-col :span="24">
          <el-form-item label="履约操作">
            <el-button size="small" type="warning" @click="handleStatus(40101)"
              >已取件</el-button
            >
            <el-button size="small" type="warning" @click="handleStatus(40002)"
              >已到达（通用）</el-button
            >
            <el-button size="small" type="warning" @click="handleStatus(41101)"
              >清洗中</el-button
            >
            <el-button size="small" type="warning" @click="handleStatus(41102)"
              >返回中</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="margin-top: 20px; text-align: right">
        <el-button type="success" @click="handleSubmit()">{{
          actionName
        }}</el-button>
        <el-button type="info" @click="handleClose()">取消操作</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { completedOrder, updateStatus } from "@/api/bussiness/order";
import workerSelector from "@/components/workerSelector.vue";
import enumSelector2 from "@/components/enumSelector2.vue";
import shortOrderInfo from "./shortOrderInfo.vue";
export default {
  components: {
    enumSelector2,
    workerSelector,
    shortOrderInfo,
  },
  data() {
    return {
      order: "",
      actionName: "完成服务",
      dataForm: {
        orderKey: "",
        name: "",
        action: "Serviced",
        mobile: "",
        commission: 0,
        bonos: 0,
      },
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "change" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "change" },
        ],
        commission: [
          { required: true, message: "请输入结算金额", trigger: "change" },
        ],
        bonos: [
          { required: true, message: "请输入好评金额", trigger: "change" },
        ],
      },
      drawerTitle: "",
      drawerVisible: false,
    };
  },
  methods: {
    workerChanged(worker) {
      if (worker) {
        this.dataForm.name = worker.Name;
        this.dataForm.mobile = worker.Mobile;
      }
    },
    show(row, action) {
      this.order = row;
      this.dataForm.orderKey = this.order.Key;
      this.dataForm.action = action;
      if (action == "Serviced") {
        this.actionName = "完成服务";
        this.drawerTitle = "商家完成服务";
      }
      if (action == "ServicedBalanced") {
        this.actionName = "完成服务并结算佣金";
        this.drawerTitle = "商家完成服务并结算佣金";
      }
      if (action == "Balanced") {
        this.actionName = "结算佣金";
        this.drawerTitle = "结算佣金";
      }
      this.dataForm.name = this.order.Worker.Name;
      this.dataForm.mobile = this.order.Worker.Mobile;
      this.dataForm.commission = this.order.WorkerCommission;
      this.dataForm.bonos = this.order.WorkerBonos;
      this.drawerVisible = true;
    },
    handleClose() {
      this.drawerVisible = false;
    },
    handleStatus(status) {
      let parma = { key: this.order.Key, status: status };
      updateStatus(parma).then((res) => {
        if (res) {
          this.msg.successMsg("操作完成！");
        }
      });
    },
    handleSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          //手机号去空格
          this.dataForm.mobile=this.dataForm.mobile.trim();
          completedOrder(this.dataForm).then((response) => {
            if (response) {
              this.drawerVisible = false;
              this.msg.successMsg("操作完成！");
              this.$emit("update");
            }
          });
        }
      });
    },
  },
  mounted() {},
};
</script>
      <style lang='scss'  scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: center;
}

/deep/.el-drawer__header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #ff862f;
}

/deep/.el-drawer__body {
  overflow-y: scroll;
}

/deep/.el-card__header {
  font-size: 16px;
}
</style>